import React from 'react';
import JobApllyButton from './JobApllyButton';

import { formatWithOptions } from 'date-fns/fp';
import { enUS, fr, de, es } from 'date-fns/locale';

const { __, getLocaleData } = window.wp.i18n;
const { __experimentalGetSettings } = window.wp.date;
// const { dateI18n } = window.wp.date;

class JobSingleBox extends React.Component {
  render() {

    function jobformatDate(date) {
        const dateFormatted = new Date(date);
        const settings = __experimentalGetSettings();

        const dateFormat = settings?.formats?.date ? settings.formats.date : 'j M Y';
        const locale = settings?.l10n?.locale.slice(0,2);

        let formatArray = {
            'F j Y' : 'dd MMM yyyy',
            'F/j/Y' : 'dd/MMM/yyyy',
            'F-j-Y' : 'dd-MMM-yyyy',
            'F j, Y' : 'dd MMM yyyy',
            'j, F Y' : 'dd MMM yyyy',
            'j-F-Y' : 'dd-MMM-yyyy',
            'j/F/Y' : 'dd/MMM/yyyy',
            'j M Y' : 'dd MMM yyyy',
            'j/M/Y' : 'dd/MMM/yyyy',
            'j-M-Y' : 'dd-MMM-yyyy',
            'j M, Y' : 'dd MMM yyyy',
            'M j, Y' : 'dd MMM yyyy',
            'Y-m-d' : 'yyyy-MM-dd',
            'm/d/Y' : 'MM/dd/yyyy',
            'd/m/Y' : 'dd/MM/yyyy',
            'F d, Y' : 'dd MMM yyyy',
            'F-d-Y' : 'dd-MMM-yyyy',
            'F/d/Y' : 'dd/MMM/yyyy',
            'd M Y' : 'dd MMM yyyy',
            'F. j. Y' : 'MMM dd. yyyy',
            'j. M. Y' : 'dd. MMM yyyy',
            'Y. m. d' : 'yyyy. MM. dd',
            'm. d. Y' : 'MM. dd. yyyy',
            'd. m. Y' : 'dd. MM. yyyy',
            'F. d. Y' : 'MMM dd. yyyy',
            'M. j. Y' : 'MMM dd. yyyy',
        };

        let dateToString = formatWithOptions({ locale: enUS }, formatArray[dateFormat]);
        switch(locale){
            case 'fr':
                dateToString = formatWithOptions({ locale: fr }, formatArray[dateFormat]);
                break;
            case 'de':
                dateToString = formatWithOptions({ locale: de }, formatArray[dateFormat]);
                break;
            case 'es':
                dateToString = formatWithOptions({ locale: es }, formatArray[dateFormat]);
                break;
            default:
                dateToString = formatWithOptions({ locale: enUS }, formatArray[dateFormat]);
        }
        const finalDate = [dateFormatted].map(dateToString)[0];
        return finalDate;
    }

    let jobSettingOptionData = this.props.SingleJobselectionData;
    let locCountry = this.props.job_data.country_name;
    let locCity = this.props.job_data.location;
    let location

    if (locCountry && !locCity) {
      location = locCountry
    } else if(!locCountry && locCity) {
      location = locCity
    } else if (!locCountry && !locCity) {
      location = null
    } else {
      location = locCity
    }

    let singleBoxData = {
      'ref_code': [this.props.job_data.ref, __( 'Ref. code', 'macs-react-jobs' )],
      'posted_on': [jobformatDate(this.props.job_data.indexed_at), __( 'Posted on', 'macs-react-jobs' )],
      'experience_level': [this.props.job_data.experience_level, __( 'Experience level', 'macs-react-jobs' )],
      'contract_type': [this.props.job_data.contract_type, __( 'Contract type', 'macs-react-jobs' )],
      'location': [location, __( 'Location', 'macs-react-jobs' )],
      'business_units': [this.props.job_data.sbu, __( 'Business unit', 'macs-react-jobs' )],
      'professional_communities': [this.props.job_data.professional_communities, __( 'Professional communities', 'macs-react-jobs' )],
      'department': [this.props.job_data.department, __( 'Department', 'macs-react-jobs' )],
      'brand': [this.props.job_data.brand, __( 'Brand', 'macs-react-jobs' )],
      'country_name': [this.props.job_data.country_name, __( 'Country', 'macs-react-jobs' )],
    }

    let selectedItems = {}
    jobSettingOptionData.map((selectedKey) => {
      if ( singleBoxData.hasOwnProperty( selectedKey ) ){
        selectedItems[selectedKey] = singleBoxData[selectedKey];
      } 
    });

    function decodeHTMLEntities(text) {
      if(text){
        var entities = [
          ['amp', '&'],
          ['apos', '\''],
          ['#x27', '\''],
          ['#x2F', '/'],
          ['#39', '\''],
          ['#47', '/'],
          ['lt', '<'],
          ['gt', '>'],
          ['nbsp', ' '],
          ['quot', '"']
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
          text = text.toString().replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);
      }
      return text;
  }
    const boxContent = Object.keys(selectedItems).map((key) => {
      if ( Array.isArray( selectedItems[key] ) && selectedItems[key][0] ) {
        return (
          <React.Fragment>
            <div className="col-sm-12 col-md-6 col-lg-12 job-meta-box-detail">
              <span className="label">{ __( selectedItems[key][1], 'macs-react-jobs' )}</span>
              <span className="value">{decodeHTMLEntities(selectedItems[key][0])}</span>
            </div>
          </React.Fragment>
        );
      }
    });

    return (
      <div className="col-sm-12 col-md-12 col-lg-3 job-meta-box">
        <div className="box">
          {
           ( boxContent.length > 0 ) ? ( <div className="row"> {boxContent} </div> ) : ''
          }
          <JobApllyButton key={this.props.job_data._id} job_data={this.props.job_data} />
        </div>
      </div>
    )
  }
}

export default JobSingleBox;
